import React from 'react';
import { is } from '../../services/classify';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Popover Component
 * @param children {ReactNode} Popover children
 * @param className {string} Additionnal CSS Classes
 * @param direction {PopoverDirection} Popover direction (DOWN|LEFT|RIGHT)
 * @param content {ReactNode} Content of the popover (hidden popover if null|undefined)
 * @param active {boolean} Is the popover active
 * @param arrowPosition {PopoverArrowPosition} Position of the popover arrow
 */
const Popover = ({ className, direction, children, active, arrowPosition, content, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('popover', direction && is(`popover-${direction}`), active && is('popover-active'), arrowPosition && is(`arrow-${arrowPosition}`), className));
    return (React.createElement("div", { "data-testid": testId, className: classes, ...others },
        children,
        content && (React.createElement("div", { "data-testid": `${testId}_content`, className: hashClass(styled, clsx('popover-content')) }, content))));
};
export default Popover;
//# sourceMappingURL=Popover.js.map